import { translate } from '../helpers/translate';
export var PlacementStatus;
(function (PlacementStatus) {
    PlacementStatus[PlacementStatus["PendingApproval"] = 0] = "PendingApproval";
    PlacementStatus[PlacementStatus["ApprovedPlacements"] = 1] = "ApprovedPlacements";
    PlacementStatus[PlacementStatus["UserDetailsPending"] = 2] = "UserDetailsPending";
    PlacementStatus[PlacementStatus["UserAdminApproval"] = 3] = "UserAdminApproval";
    PlacementStatus[PlacementStatus["PlacementComplete"] = 4] = "PlacementComplete";
})(PlacementStatus || (PlacementStatus = {}));
export const PlacementStatusMap = new Map([
    [PlacementStatus.PendingApproval, translate('enums.placementStatus.pendingApproval')],
    [PlacementStatus.ApprovedPlacements, translate('enums.placementStatus.approvedPlacements')],
    [PlacementStatus.UserDetailsPending, translate('enums.placementStatus.userDetailsPending')],
    [PlacementStatus.UserAdminApproval, translate('enums.placementStatus.userAdminApproval')],
    [PlacementStatus.PlacementComplete, translate('enums.placementStatus.placementComplete')]
]);
